import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { companyService } from '../../company/service/company.service';

export function useCompanyBranding() {
  const { companySlug } = useParams<{ companySlug: string }>();

  const { data: company } = useQuery({
    queryKey: ['company-branding', companySlug],
    queryFn: () => companyService.getCompanyPublic(companySlug!),
    enabled: !!companySlug,
    staleTime: 5 * 60 * 1000,
  });

  React.useEffect(() => {
    if (!company) return;
    const root = document.documentElement;
    if (company.primaryColor) root.style.setProperty('--color-brand-primary', company.primaryColor);
    if (company.secondaryColor) root.style.setProperty('--color-brand-secondary', company.secondaryColor);
    if (company.accentColor) root.style.setProperty('--color-brand-accent', company.accentColor);

    return () => {
      root.style.setProperty('--color-brand-primary', '#0ea5c9');
      root.style.setProperty('--color-brand-secondary', '#1D1D1E');
      root.style.setProperty('--color-brand-accent', '#5DE1FF');
    };
  }, [company]);

  return {
    companyName: (company as any)?.name ?? null,
    logoUrl: (company as any)?.logoUrl ?? null,
    isCompanyContext: !!companySlug && !!company,
    slug: companySlug ?? null,
  };
}
